export const GET = Object.freeze({
  REQUEST: 'unit/GET_REQUEST',
  SUCCESS: 'unit/GET_SUCCESS',
  ERROR: 'unit/GET_ERROR',
});

export const FIND = Object.freeze({
  REQUEST: 'unit/FIND_REQUEST',
  SUCCESS: 'unit/FIND_SUCCESS',
  ERROR: 'unit/FIND_ERROR',
});

export const CREATE = Object.freeze({
  REQUEST: 'unit/CREATE_REQUEST',
  SUCCESS: 'unit/CREATE_SUCCESS',
  ERROR: 'unit/CREATE_ERROR',
});

export const UPDATE = Object.freeze({
  REQUEST: 'unit/UPDATE_REQUEST',
  SUCCESS: 'unit/UPDATE_SUCCESS',
  ERROR: 'unit/UPDATE_ERROR',
});

export const DELETE = Object.freeze({
  REQUEST: 'unit/DELETE_REQUEST',
  SUCCESS: 'unit/DELETE_SUCCESS',
  ERROR: 'unit/DELETE_ERROR',
});

export const GET_UNITS_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET.ERROR,
    payload,
    error: true,
  }),
});

export const FIND_UNIT_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: FIND.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: FIND.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: FIND.ERROR,
    payload,
    error: true,
  }),
});

export const CREATE_UNIT_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: CREATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: CREATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: CREATE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_UNIT_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE.ERROR,
    payload,
    error: true,
  }),
});

export const DELETE_UNIT_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: DELETE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: DELETE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: DELETE.ERROR,
    payload,
    error: true,
  }),
});
